import {
  Error,
  GetAllMainAccount,
  GetOneMainAccount,
  DeleteOneMainAccount,
  InsertOneMainAccount,
  UpdateOneMainAccount,
  GetAllMainAccountByAccounttype,
  GetAllMainfileAccount,
} from "../type";
const initialState = {
  MainAccounts: [],
  MainAccountsFileid: [],
  CreateMainAccounts: [],
  DeleteAccounts: [],
  UpdateAccounts: [],
  OneAccounts: [],
  MainAccountsAccType: [],
  loading: false,
};
const MainAccountR = (state = initialState, action) => {
  switch (action.type) {
    case GetAllMainAccount:
      return {
        ...state,
        MainAccounts: action.payload,
        loading: false,
      };
    case GetAllMainfileAccount:
      return {
        ...state,
        MainAccountsFileid: action.payload,
        loading: false,
      };
    case GetOneMainAccount:
      return {
        OneAccounts: action.payload,
        loading: false,
      };
    case InsertOneMainAccount:
      return {
        MainAccountsFileid:state.MainAccountsFileid,
        CreateMainAccounts: action.payload,
        loading: false,
      };
    case UpdateOneMainAccount:
      return {
        MainAccountsFileid:state.MainAccountsFileid,
        UpdateAccounts: action.payload,
        loading: false,
      };
    case DeleteOneMainAccount:
      return {
        MainAccountsFileid:state.MainAccountsFileid,
        DeleteAccounts: action.payload,
        loading: false,
      };
    case GetAllMainAccountByAccounttype:
      return { 
        ...state,
        MainAccountsAccType: action.payload,
        loading: false,
      };
    case Error:
      return {
        loading: false,
        MainAccounts: action.payload,
      };
    default:
      return state;
  }
};
export default MainAccountR;
